import { render } from "./Equipamentos.vue?vue&type=template&id=791d9e02"
import script from "./Equipamentos.vue?vue&type=script&lang=js"
export * from "./Equipamentos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__